<template>
	<div class="container" v-if="user">
    <div class="content">
			<div class="link-listing" :class="{'scrolled-down': $mq.isDesktop() && scrollDown}">
				<div class="link-listing_inner">
					<template
						v-for="(navItem, i) in nav"
						v-if="show(navItem)"
					>
						<router-link
							class="link flex-vcenter"
							event=''
							:to="{name: navItem.link}"
							:key="`navItemProfile${i}`"
							:id="navItem.link"
							@click.native="navigate(navItem)"
							v-if="navItem.enabled"
						>
							<span v-html="navItem.label" />
							<span class="flex-right" v-if='!$mq.isDesktop()'>
								<i
									class="fa fa-chevron-right flex-center"
									:class="{transformed: navItem.link === $route.name}"
								/>
							</span>
						</router-link>

						<div
							class="main"
							v-if="!$mq.isDesktop() && navItem.link === $route.name"
							:key="`contentProfile${i}`"
						>
							<router-view
								:user="user"
							/>
						</div>
					</template>

					<a class="link flex-vcenter" id="password" href="" @click.prevent="$_auth_logout()">
						<i class="fas fa-sign-out-alt" />&nbsp;Logout
					</a>
					<br>
					<router-link
						:to="{name: 'legal'}"
						class="link-detail"
						:title='$t("components.checkbox.general_conditions")'
						v-html="$t('components.footer.bottom_bar.privacy_link')"
						v-if="$mq.isWV()"
					/>
					<br>
					<br>
				</div>
			</div>

			<div class="main" v-if="$mq.isDesktop()">
				<router-view
					:user="user"
				/>
			</div>
		</div>
	</div>
</template>

<script>

import { scrollToElementId } from '../../assets/js/main'

import { menuStore } from '../../store/menuStore' 

import { auth } from '../../mixins/login'

import MenuAlert from '../Checkout/MenuAlert'
import BannerGreeting from '../Parts/BannerGreeting'
export default {
	mixins: [
		auth,
	],

	components: {
		BannerGreeting,
		MenuAlert
	},

	data () {
		return {
			menuStore: menuStore.state,
			scrollDown: false,
			openSection: null,

			pos: null,

			nav: [
				/* {
					link: 'profile_next-order',
					label: '<i class="fa fa-arrow-right" aria-hidden="true"></i> Ordine in corso',
					subscriptionReq: true,
					activeSubscriptionReq: true,
					enabled: true
				}, */
				{
					link: 'profile_orders',
					label: '<i class="fa fa-archive" aria-hidden="true"></i> Le mie spese',
					subscriptionReq: false,
					enabled: true
				},
				{
		          link: 'profile_account',
		          label: '<i class="fa fa-user" aria-hidden="true"></i> Account',
		          enabled: true 
		        },
				{
		          link: 'profile_subscription',
		          label: '<i class="fa fa-calendar-alt aria-hidden="true"></i> Abbonamento',
							subscriptionReq: true,
		          enabled: this.$root.source === 'enel' ? false : true 
		        },
				{
					link: 'profile_shipment',
					label: '<i class="fa fa-truck" aria-hidden="true"></i> Indirizzo e giorno di consegna',
					subscriptionReq: true,
					enabled: true
				},
				{
					link: 'profile_invite-friend',
					label: '<i class="fa fa-user-plus" aria-hidden="true"></i> Invita un amico',
					subscriptionReq: true,
					enabled: true
				},
				{
					link: 'freshdesk',
					label: '<i class="fas fa-info-circle"></i> Aiuto'
				}
			]
		}
	},

	watch: {
		user () {
			if (!this.user) this.$router.push({name: 'home'})
		},

		$route () {
			this.routeHandler()
			this.$nextTick(_ => {
				scrollToElementId(this.$mq.isDesktop() ? null : this.$route.name)
			})
		}
	},

	computed: {
		user () {
			return this.$root.$data.user
		},

		menu () {
			return this.menuStore.menu
		}
	},

	methods: {
		show (navItem) {
			const subscription = () => navItem.subscriptionReq ? this.user.subscription && !this.user.subscription.is_pending : true
			const subscriptionActive = () => navItem.activeSubscriptionReq ? this.user.subscription.is_started : true

			return subscription() && subscriptionActive()
		},

		scrollHandler () {
			var currentPosition = 0
			this.$nextTick(_ => {
				window.addEventListener('scroll', _ => {
					const scrollDown = () => window.scrollY > currentPosition && window.scrollY > 10
					this.scrollDown = !!scrollDown()
					currentPosition = window.scrollY
				})
			})
		},

		navigate (navItem) {
			const isMobile = () => !this.$mq.isDesktop()
			const isClickOnNewSection = () => this.$route.name !== navItem.link
			this.$router.push({ name: isMobile() ? isClickOnNewSection() ? navItem.link : 'profile' : navItem.link })
		},

		routeHandler () {
			if (this.$route.name === 'profile' && this.$mq.isDesktop()) {
				this.$router.push({name: 'profile_subscription'})
			}
		},

		geolocateMe () {
			return
			if (this.$mq.isWV()) {
				if (navigator.geolocation) {
		         	navigator.geolocation.getCurrentPosition((position) => {
			            var pos = {
			             	lat: position.coords.latitude,
			            	lng: position.coords.longitude
			            }

						return 

					}, function() {
		          	})
			  
		        } else {
		        	console.log('no navigator.geolocation')
		        }
			}
		}
	},

	mounted () {
		this.scrollHandler()
		this.routeHandler()
		this.$nextTick(_ => {
			scrollToElementId(this.$mq.isDesktop() ? null : this.$route.name)
		})
		menuStore.loadCurrentMenu()
	}
}

</script>

<style scoped>
.container >>> section + section {
	padding-top: 30px;
	/*border-top: 1px solid #ededed;*/
}

.container >>> section {
	padding-bottom: 30px;
}

.container >>> section:last-child {
	padding-bottom: 0px;
}

.container >>> h3 {
	text-align: left;
	margin-bottom: 20px;
}

.container {
	background-color: #EDEDED;
	min-height: auto;
}

.container >>> .listing {
	margin: 0 -10px;
}

.container >>> .equal {
	margin-bottom: 30px;
	flex-basis: calc(100% / 2 - 20px);
	flex-grow: 1;
	margin: 0 10px;
	margin-bottom: 30px;
}

.container >>> .button-group {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.container >>> .label {
	min-width: 200px;
}

.content {
	padding: 20px 0 0 0;
	position: relative;
	display: flex;
	justify-content: center;
	max-width: 100%;
}

.bar-greeting + .content {
	padding-top: 80px;
}

.main {
	width: 100%;
	padding: 30px;
	min-height: 200px;
	background-color: white;
	border-radius: 6px;
	margin-bottom: 30px;
	margin-right: 20px;
	margin-left: 20px;
	max-width: calc(100% - 320px);
}

.fa {
	min-width: 18px;
}

.link-listing {
	width: 100%;
	padding: 20px 30px;
	max-width: 280px;
	transition: 0.5s ease all;
}

.link-listing_inner {
	position: -webkit-sticky;
	position: sticky;
	top: 100px;
}

.link-listing .link {
	cursor: pointer;
	padding-bottom: 20px;
	border-radius: 4px;
	padding-left: 10px;
}

.link-listing .link:hover {
	color: var(--quomi-primary);
}

.router-link-active {
	color: var(--quomi-primary);
	font-weight: bold;
}

.scrolled-down {
	transform: translateY(-55px);
}

.fa-chevron-right {
	margin-left: 10px;
	transition: transform 0.3s ease;
}

.fa-chevron-right.transformed {
	transform: rotate(90deg);
}

@media (max-width: 700px) {
	.container >>> .button-group {
		flex-wrap: wrap;
	}

	.container >>> .button-group .button {
		margin-top: 10px;
	}
}

@media (max-width: 1024px) {

	.main {
		margin-top: -6px;
		margin-right: 0px;
		margin-left: 0px;
		padding: 15px;
		max-width: 100%;
	}

	.link-listing_inner .link + .link {
		margin-top: 12px;
	}

	.link-listing_inner .link {
		background-color: white;
		width: 100%;
		padding: 15px;
	}

	.link-listing {
		padding: 0 10px;
		max-width: 100%;
	}
}
</style>
